import styled from "styled-components/macro";

export const BlankBox = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0%;
  background: black;
`;

export const DisclaimerBg = styled.div`
  width: 100%;
  height: 101.9%;
  position: absolute;
  top: -1%;
  left: 0%;
  /* background: #337fbf; */
  background: white;
  border: none;
  /* display: flex; */
  /* justify-content: space-around; */
  /* flex-direction: column; */
  text-align: center;
  font-size: .9rem;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* font-family: Arial, Helvetica, sans-serif; */
`;

export const DisclaimerBox = styled.div`
  border-radius: 1rem;
  border-width: 1px;
  border-style: solid;
  border-color: #a0aec0;
  /* padding: 1rem; */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

/* border: 1px solid blue; */
margin: 10px;
/* padding:1.5rem; */
/* margin-left: 10px;
margin-right: 10px;
margin-bottom: 10px; */
/* padding-bottom: 10px; */

`;

export const DisclaimerText = styled.div`
  text-align: left;
  margin: 2.5rem .85rem;
  /* padding-left: 1.5rem; */
  /* padding-top:1rem; */
  /* padding-bottom: 1.5rem; */
  /* padding-right: 1rem; */
  color: black;
  font-size: small;

  /* font-weight: 100; */

`;

export const DisclaimerTitleBox = styled.div`
  display: flex;
  justify-content: center;
  /* font-size: 1.5rem; */
  font-size: 1.25rem;
  gap: .5em;

  /* gap: 1em; */
  margin-left: -1em;
  /* margin: 1em; */
  /* padding-top: 1em; */
  padding-bottom: 10px;
`;

export const DisclaimerLogoContainer = styled.div`
  /* margin-top: 6em; */
  /* margin-bottom: 3rem; */
  /* height: 90px; */
  height: 25px;
  width: 100px;
  width: auto;
`;
export const DisclaimerLogo = styled.img`
  object-fit: contain;
`;


export const DisclaimerButtonWrapper = styled.div`
  /* padding-right: 1em; */
  display: flex;
  justify-content: center;
  /* justify-content: flex-end; */

  /* margin-top: 1em; */
  gap: 0.5em;
  margin-bottom: 10px;
`